import { render } from "./AddMonthlyContentModal.vue?vue&type=template&id=6d8f5d0c"
import script from "./AddMonthlyContentModal.vue?vue&type=script&lang=js"
export * from "./AddMonthlyContentModal.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__